import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import ReviewSection from "./ReviewSection.js";
const ReviewSummary = ({ summarizedPositiveText, summarizedNegativeText, showThumbsDown })=>/*#__PURE__*/ jsxs("div", {
        className: "flex flex-col gap-2 py-1",
        children: [
            /*#__PURE__*/ jsx(ReviewSection, {
                text: summarizedPositiveText,
                type: 'up'
            }),
            showThumbsDown ? /*#__PURE__*/ jsx(ReviewSection, {
                text: summarizedNegativeText,
                type: 'down'
            }) : null
        ]
    });
const ReviewSummary_ReviewSummary = ReviewSummary;
export { ReviewSummary_ReviewSummary as default };
